import {Component, OnInit} from '@angular/core';
import {catchError, debounceTime, distinctUntilChanged, map, switchMap, tap} from 'rxjs/operators';
import {Observable, of} from 'rxjs';
import {
  ModalDismissReasons,
  NgbHighlight,
  NgbModal,
  NgbModalRef,
  NgbPaginationModule,
  NgbTypeahead
} from '@ng-bootstrap/ng-bootstrap';
import {CommonModule, DatePipe} from '@angular/common';
import {ToastrService} from 'ngx-toastr';
import {ConsultingService, LoaderService} from '@app/shared/services';
import {OrderService} from '@app/shared/services/order.service';
import {environment} from '@env/environment';
import {PageHeaderComponent} from '@app/components/page-header/page-header.component';
import {FormsModule} from '@angular/forms';
import {RouterLink} from '@angular/router';
import {SelectDropDownModule} from 'ngx-select-dropdown';
import {NgMultiSelectDropDownModule} from 'ng-multiselect-dropdown';
import {NgxMaskDirective, provideNgxMask} from 'ngx-mask';
import {NgxBarcode6Module} from 'ngx-barcode6';
import {UtilsInjectable} from '@app/shared';
import {PaginationComponent} from '@app/components/pagination/pagination.component';

@Component({
  selector: 'app-purchase-list',
  templateUrl: './purchase-list.component.html',
  imports: [
    CommonModule,
    FormsModule,
    DatePipe,
    PageHeaderComponent,
    RouterLink,
    NgbPaginationModule,
    NgbHighlight,
    SelectDropDownModule,
    NgMultiSelectDropDownModule,
    NgbTypeahead,
    NgxMaskDirective,
    NgxBarcode6Module,
    PaginationComponent
  ],
  styleUrls: ['./purchase-list.component.scss'],
  providers: [provideNgxMask()]
})
export class PurchaseListComponent implements OnInit {
  public env = environment;
  user_rights: any;
  user_data: any;
  public order_list: any = [];


  public purchase_details: any = [{check: true}];
  checked = false;
  public purchase: any =
    {
      vendor_id: '',
      invoice_no: '',
      invoice_date: new Date(),
      purchase_id: '',
      medicine_data: [],
      medicine_id_arr: [""],
      quantity_arr: [""],
      uom_arr: [""],
      uom_arr_name: [""],
      paking_arr: [""],
      amount_arr: [""],
      actual_arr: [""],
      unitprice_arr: [""],
      retailprice_arr: [""],
      dis_arr: [""],
      order_quantity_arr: [""],
      order_quantity: [""],
      received_quantity: [""],
      freebie_arr: ["0"],
      purchased_quantity_arr: [""],
      vat_arr: [""],
      vat_amt_arr: [""],
      gross_arr: [""],
      check: [false],
      discount: 0,
      freight_charge: 0,
      disc_per: 0,
      user_id: '',
      customer_trn: "",
      sor_no: {},
      customer_ref: "",
      sales_person: "",
      state_code: "",
      warehouse_details_id: [""],
      purchase_details_id: [""],
      edit_qty_arr: ["0"],
      ava_qty_arr: [""],
      upload_file: [],
      removeUpload: [],
      warehouse: [""]
    }
  searching = false;
  searchFailed = false;
  date: any;
  unit: any;
  purchase_data: any;
  total_amount = 0;
  start = 0;
  limit = 10;
  p = 50;
  public collection: any = '';
  page = 1;
  index: any;
  status: any;
  vendor: any;
  vendor_options: any;
  vendor_data: any = [];
  purchased: any;
  item_list: any;
  dropdownSettings = {};
  net_total = 0;
  medicine_data: any;
  public now = new Date();
  public count = 1;
  public count_arr: any = [""];
  closeResult = '';
  total = 0;
  price_total = 0;
  disc_total = 0;
  print_barcode: any;

  purchase_id: any;
  purchased_quantity_arr: any = [""];
  public purchase_credit: any =
    {
      search_purchase: '',
      vat_credit: 0,
      credit_date: new Date(),
      purchase_id: '',
      user_id: "",

    }
  public purchase_received: any =
    {
      received: 0,
      credit_date: new Date(),
      payment_received: 0,
      purchase_id: '',
      user_id: "",
    }
  result_status: any;
  fileName: any = [];
  filelist: any;
  file_list: any = [];
  grand_total: any;
  warehouse: any;
  private modalRef?: NgbModalRef;

  constructor(private loaderService: LoaderService,
              private modalService: NgbModal,
              public orderService: OrderService,
              public consultingService: ConsultingService,
              public utils: UtilsInjectable,
              private toastr: ToastrService,) {

  }

  ngOnInit() {
    this.user_rights = JSON.parse(localStorage.getItem('user_rights') || "");
    this.user_data = JSON.parse(localStorage.getItem('user') || "");
    this.purchase_credit.user_id = this.user_data.user_id
    this.getPurchaseList();
    this.getDropdowns();
    this.getUnitList();
    this.listOrderNo();
    this.listWarehouse();
    this.dropdownSettings = {
      singleSelection: false,
      idField: 'PURCHASE_ORDER_ID',
      textField: 'PURCHASE_ORDER_NUMBER',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 2,
      allowSearchFilter: true
    };
  }

  public listWarehouse() {

    const postData = {
      warehouse_id: '0'
    };
    this.loaderService.display(true);
    window.scrollTo(0, 0);
    this.loaderService.display(true);
    this.consultingService.listWarehouse(postData).subscribe((result: any) => {
      if (result['status'] == 'Success') {
        this.warehouse = result['data'];
        this.loaderService.display(false);
      } else {
        this.loaderService.display(false);
      }
    });
  }

  selectFiles($event: any) {
    if ($event.target.files && $event.target.files[0]) {
      const filesAmount = $event.target.files.length;
      for (let i = 0; i < filesAmount; i++) {
        this.fileName.push($event.target.files[i])
        const reader = new FileReader();
        reader.onload = (event: any) => {
          const image = event.target.result;
          const splitted = image.split(",");
          this.purchase.upload_file.push(splitted[1]);
        }
        reader.readAsDataURL($event.target.files[i]);
      }

    }
  }

  public edit(data: any) {
    this.purchase_id = data
  }

  public payment_pop(purchase_id: any) {
    this.purchase_received.purchase_id = purchase_id;
  }

  public selectpaymentcredit(val: any) {
    this.purchase_received.received = val;
    if (val == 0) {
      this.purchase_received.received_date = '';
    }
  }

  public savePurchaseReceived(content: any) {
    this.purchase_received.user_id = this.user_data.user_id;
    if (this.purchase_received.received_date == '' && this.purchase_received.received == 1 || this.purchase_received.received_date == null && this.purchase_received.received == 1) {
      this.toastr.error("Please select the received date!!")
      this.credit(content);
    } else {
      if (this.purchase_received.received == 0) {
        this.purchase_received.received_date = ''
      }
      this.loaderService.display(true);
      window.scrollTo(0, 0);
      this.loaderService.display(true);
      this.orderService.savePurchaseReceived(this.purchase_received).subscribe((result: any) => {
        if (result['status'] == 'Success') {
          this.toastr.success(result["msg"]);
          this.getPurchaseList()
          this.loaderService.display(false);
        } else {
          this.loaderService.display(false);
        }
      });
    }
  }

  getSum() {
    let price = 0;
    let disc = 0;

    for (const item of this.item_list) {
      price = price + parseFloat(item.GROSS_AMOUNT);
      disc = disc + parseFloat(item.DISCOUNT);

    }
    this.price_total = price;

    this.net_total = Math.round(price + parseFloat(this.purchased.FREIGHT_CHARGE) - this.purchased.DISCOUNT);

    this.disc_total = disc;

  }

  public printCount(count: any) {
    this.count_arr = [""];
    for (let i = 1; i < count; ++i) {
      this.count_arr.push(i);
    }
  }

  public getPurchaseList(page = 1) {
    this.page = page;
    const limit = 50;
    this.start = (page-1) * limit;
    this.limit = limit;
    const postData = {
      start: this.start,
      limit: this.limit,
      purchase_id: '0'
    };
    this.loaderService.display(true);
    window.scrollTo(0, 0);
    this.loaderService.display(true);
    this.consultingService.listPurchase(postData).subscribe((result: any) => {
      if (result['status'] == 'Success') {
        this.purchase_data = result['data'];
        this.collection = result['total_count'];
        this.grand_total = Math.round(result['grand_total']);
        for (const data of this.purchase_data) {
          data["TOTAL"] = Math.round(parseFloat(data.TOTAL_AMOUNT) - parseFloat(data.DISCOUNT) + parseFloat(data.FREIGHT_CHARGE))
        }
        this.loaderService.display(false);
      } else {
        this.loaderService.display(false);
        this.collection = 0;
      }
    });
  }

  getsearchlist() {
    const limit = 50;
    this.start = 0;
    this.limit = limit;
    const postData = {
      start: this.start,
      limit: this.limit,
      search_text: this.purchase_credit.search_purchase,
      purchase_id: '0'
    };
    this.loaderService.display(true);
    window.scrollTo(0, 0);
    this.loaderService.display(true);
    this.consultingService.listPurchase(postData).subscribe((result: any) => {
      if (result['status'] == 'Success') {
        this.purchase_data = result['data'];
        this.collection = result['total_count'];
        const i = this.purchase_data.length;
        this.index = i + 5;
        this.status = result['status'];
        this.loaderService.display(false);
      } else {
        this.loaderService.display(false);
        this.collection = 0;
        this.status = result['status'];
      }
    });
  }

  public clear_search() {
    if (this.purchase_credit.search_purchase != '') {
      this.purchase_credit.search_purchase = '';
      this.getPurchaseList();
    }
  }

  public purached_items(item: any) {
    const postData = {
      purchase_id: item.PURCHASE_ID
    };
    this.loaderService.display(true);
    window.scrollTo(0, 0);
    this.loaderService.display(true);
    this.consultingService.getPurchase(postData).subscribe((result: any) => {
      if (result['status'] == 'Success') {
        this.purchased = result['data'];
        this.purchase_credit.vat_credit = this.purchased.VAT_CREDIT
        this.purchase_credit.credit_date = this.purchased.VAT_CREDIT_DATE
        this.purchase_received.received = this.purchased.RECEIVED
        this.purchase_received.received_date = this.purchased.RECEIVED_DATE
        this.item_list = result['data'].PURCHASE;
        this.file_list = result['data'].ATTACHMENTS;
        this.getSum();
        this.listWarehouse();
        this.loaderService.display(false);
      } else {
        this.loaderService.display(false);
      }
    });
  }

  public generateBarcode(item: any) {

    this.count = 1;
    const postData = {

      purchase_details_id: item.PURCHASE_DETAILS_ID
    };
    this.loaderService.display(true);
    window.scrollTo(0, 0);
    this.loaderService.display(true);
    this.consultingService.generateBarcode(postData).subscribe((result: any) => {
      if (result['status'] == 'Success') {
        this.print_barcode = result['data'];
        this.loaderService.display(false);
      } else {
        this.loaderService.display(false);
      }
    });
  }

  printBarcode(): void {
    const printContents = document.getElementById('printBarcode')?.innerHTML;
    const popupWin = window.open('', '_blank', 'left=0,top=0,width=900,height=900,toolbar=0,scrollbars=0,status=0');
    popupWin?.document.open();
    popupWin?.document.write(`
      <html lang="en">
        <head>
          <title>Print tab</title>
          <style>
          //........Customized style.......
          </style>
        </head>
    <body onload="window.print();window.close()">${printContents}</body>
      </html>`
    );
    popupWin?.document.close();
  }

  public getToday(): string {
    return new Date().toISOString().split('T')[0]
  }

  public vat_pop(purchase_id: any) {
    this.purchase_credit.purchase_id = purchase_id;
  }

  public selectVatcredit(val: any) {
    this.purchase_credit.vat_credit = val;
  }

  public saveVATCredit() {

    if (this.purchase_credit.purchase_id != 0 && this.purchase_credit.purchase_id != null) {
      this.loaderService.display(true);
      window.scrollTo(0, 0);
      this.loaderService.display(true);
      this.consultingService.saveVATCredit(this.purchase_credit).subscribe((result: any) => {
        if (result['status'] == 'Success') {
          this.toastr.success(result["msg"]);
          this.getPurchaseList()
          this.loaderService.display(false);
        } else {
          this.loaderService.display(false);
        }
      });
    }
  }

  public finalize(purchase_id: any) {
    if (confirm("Are you sure to finalize this purchase ?")) {
      const postData = {
        purchase_id: purchase_id,
        user_id: this.user_data.user_id
      }
      this.loaderService.display(true);
      this.consultingService.PurchaseFinalize(postData).subscribe((result: any) => {
        window.scrollTo(0, 0)
        if (result["status"] == "Success") {
          this.loaderService.display(false);
          this.toastr.success(result.msg);
          this.purchase.purchase_id = result.data_id;
          this.getPurchaseList();

        } else {
          this.toastr.error(result.msg);
          this.loaderService.display(false);
        }
      })
    }
  }

  public listOrderNo() {

    const postData = {
      vendor_id: this.purchase.vendor_id
    };
    this.loaderService.display(true);
    window.scrollTo(0, 0);
    this.loaderService.display(true);
    this.orderService.listOrderNo(postData).subscribe((result: any) => {
      if (result['status'] == 'Success') {
        this.order_list = result['data'];
        this.loaderService.display(false);
      } else {
        this.order_list = "";
        this.loaderService.display(false);
      }
    });
  }

  getVendor() {
    this.purchase.sor_no = {};
    this.purchase.vendor_id = this.vendor_data.VENDOR_ID;
    this.purchase.customer_trn = this.vendor_data.TRN_NO;

  }

  public setVendor() {
    if (this.purchase.vendor_id) {
      for (let index = 0; index < this.vendor.length; index++) {
        if (this.vendor[index].VENDOR_ID == this.purchase.vendor_id) {
          this.vendor_data = this.vendor[index];
          break;
        }
      }
    }
  }

  public set_item_medicine($event: any, i: any) {
    this.purchase.purchased_quantity_arr[i] = ''
    this.purchase.amount_arr[i] = ''
    this.purchase.unitprice_arr[i] = ''
    this.purchase.retailprice_arr[i] = ''
    this.purchase.freebie_arr[i] = '0'
    this.purchase.gross_arr[i] = ''
    this.purchase.vat_amt_arr[i] = ''
    this.purchase.gross_arr[i] = ''

    const item = $event.item;
    this.purchase.medicine_id_arr[i] = item.MEDICINE_ID;
    this.purchase.uom_arr[i] = item.UNIT;
    this.purchase.uom_arr_name[i] = item.UNIT_DESC;
    this.purchase.order_quantity_arr[i] = item.ORDER_QUANTITY;
    this.purchase.received_quantity[i] = item.RECEIVED_ORDER_QUANTITY;
    if (this.purchase.sor_no.length > 0) {
      this.purchase.order_quantity[i] = item.RECEIVED_ORDER_QUANTITY + ' / ' + item.ORDER_QUANTITY;
    }
    this.purchase.vat_arr[i] = item.VAT;

    this.getMedicine(item, i);

  }

  public getUnitList() {

    const postData = {
      unit_id: '0'
    };
    this.loaderService.display(true);
    window.scrollTo(0, 0);
    this.loaderService.display(true);
    this.consultingService.listUnit(postData).subscribe((result: any) => {
      if (result['status'] == 'Success') {
        this.unit = result['data'];
        this.loaderService.display(false);
      } else {
        this.loaderService.display(false);
      }
    });
  }

  public attachmentPath(filename: any) {
    let path: string;
    path = environment.PURCHASE_UPLOAD_PATH + filename;

    return path;
  }

  public clear_purchase() {
    this.purchase_details = [{check: true}];
    this.total_amount = 0;
    this.purchase = {
      vendor_id: '',
      invoice_no: '',
      invoice_date: new Date(),
      purchase_id: 0,
      medicine_data: [],
      medicine_id_arr: [""],
      purchase_details_id: [""],
      warehouse_details_id: [""],
      quantity_arr: [""],
      purchased_quantity_arr: [""],
      uom_arr: [""],
      uom_arr_name: [""],
      paking_arr: [""],
      amount_arr: [""],
      actual_arr: [""],
      edit_qty_arr: ["0"],
      ava_qty_arr: [""],
      unitprice_arr: [""],
      retailprice_arr: [""],
      dis_arr: [""],
      order_quantity_arr: [""],
      received_quantity: [""],
      order_quantity: [""],
      freebie_arr: ["0"],
      vat_arr: [""],
      gross_arr: [""],
      vat_amt_arr: [""],
      check: [""],
      discount: 0,
      freight_charge: 0,
      disc_per: 0,
      user_id: '',
      sor_no: {},
      upload_file: [],
      removeUpload: [],
      warehouse: [""],
      customer_ref: "",
      sales_person: "",
      state_code: ""

    }
    this.fileName = []
    this.vendor_data = ""
    this.net_total = 0
    this.getDropdowns();
  }

  public UpdatePurchase(): any {
    let rel = 1;
    this.purchase.medicine_id_arr.forEach((_item: any, index: any) => {

      if (this.purchase.warehouse[index] == '' || this.purchase.warehouse[index] == null) {
        rel = 0;
      }
    });
    if (rel == 0) {
      this.toastr.error('Please select warehouse!');
      return false;
    }
    this.purchase.user_id = this.user_data.user_id
    this.loaderService.display(true);
    this.orderService.UpdatePurchase(this.purchase).subscribe((result: any) => {
      window.scrollTo(0, 0)
      if (result["status"] == "Success") {
        this.loaderService.display(false);
        this.toastr.success(result.msg);
        this.modalRef?.close();
        this.clear_purchase()
        this.getPurchaseList();
        this.purchase.puchase_id = result.data_id;
        this.purchase.edit_qty_arr = ["0"];
      } else {
        this.toastr.error(result.msg);
        this.loaderService.display(false);
      }
    })
  }

  public getMedicine(data: any, i: any) {
    const postData = {
      medicine_id: data.MEDICINE_ID
    };
    this.loaderService.display(true);
    this.loaderService.display(true);
    this.consultingService.getMedicine(postData).subscribe((result: any) => {
      if (result['status'] == 'Success') {
        const medilist_data = result['data'];
        this.purchase.medicine_name = medilist_data.TRADE_NAME;
        this.purchase.medicine_code = medilist_data.DDC_CODE;
        this.purchase.medicine_id_arr[i] = medilist_data.MEDICINE_ID;
        this.loaderService.display(false);
      } else {
        this.loaderService.display(false);
      }

    });
  }

  public changeCalculation(i: any) {
    const hidden_qty = parseInt(this.purchased_quantity_arr[i]);
    const edit = parseInt(this.purchase.edit_qty_arr[i]);
    if (!isNaN(edit)) {
      this.purchase.purchased_quantity_arr[i] = hidden_qty + edit
    }
    if (isNaN(edit)) {
      this.purchase.purchased_quantity_arr[i] = hidden_qty
    }

  }

  public validateNumber(event: any) {
    const keyCode = event.keyCode;
    const excludedKeys = [8, 37, 39, 46];
    if (!((keyCode >= 48 && keyCode <= 57) ||
      (keyCode >= 96 && keyCode <= 105) || (keyCode == 109) || (keyCode == 173) ||
      (excludedKeys.includes(keyCode)))) {
      event.preventDefault();
    }
  }

  public keyDownFunction(event: any) {
    if (event.keyCode == 13) {
      this.getsearchlist();
    }
  }

  onSelectAll(items: any) {
    this.purchase.sor_no = items
  }

  public getDropdowns() {
    const postData = {
      vendor_id: ''
    }

    this.loaderService.display(true);
    this.consultingService.listVendor(postData).subscribe((result: any) => {
      this.loaderService.display(false);
      if (result['status'] == 'Success') {
        this.vendor = result['data'];
        this.vendor_options = this.vendor;
        this.setVendor();

      }
    });
  }

  removeFile(id: any) {
    this.purchase.removeUpload.push(id);
  }

  public getPurchaseDetails(id: any) {
    this.getDropdowns();
    this.fileName = []
    this.purchase.removeUpload = []
    this.purchase.upload_file = []
    const postData = {

      purchase_id: id
    };

    window.scrollTo(0, 0);
    this.consultingService.getPurchase(postData).subscribe((result: any) => {
      if (result['status'] == 'Success') {
        this.purchased = result['data'];
        this.filelist = result['data'].ATTACHMENTS;
        this.purchase.vendor_id = this.purchased.VENDOR_ID;
        this.purchase.state_code = this.purchased.VENDOR_STATECODE;
        this.purchase.invoice_no = this.purchased.INVOICE_NUMBER;
        this.purchase.invoice_date = this.purchased.INVOICE_DATE;
        this.purchase.purchase_id = this.purchased.PURCHASE_ID;
        this.purchase.customer_trn = this.purchased.CUSTOMER_TRN;
        this.purchase.sor_no = this.purchased.ORDER_NUMBER;
        this.purchase.customer_ref = this.purchased.CUSTOMER_REFERENCE;
        this.purchase.sales_person = this.purchased.SALES_PERSON;
        this.purchase.discount = this.purchased.DISCOUNT;
        this.purchase.freight_charge = this.purchased.FREIGHT_CHARGE;

        let i = 0;
        const num_rows = [];
        this.getDropdowns();
        this.setVendor();
        this.listOrderNo();
        for (const val of result['data'].PURCHASE) {
          const temp = {
            'MEDICINE_ID': val.MEDICINE_ID,
            'TRADE_NAME': val.TRADE_NAME,
          };

          num_rows.push(i);
          this.purchase.medicine_data[i] = temp;
          this.purchase.purchase_details_id[i] = val.PURCHASE_DETAILS_ID
          this.purchase.warehouse_details_id[i] = val.WAREHOUSE_STOCK_DETAIL_ID
          this.purchase.medicine_id_arr[i] = val.MEDICINE_ID;
          this.purchase.purchased_quantity_arr[i] = val.PURCHASED_QUANTITY;
          this.purchased_quantity_arr[i] = val.PURCHASED_QUANTITY;
          this.purchase.freebie_arr[i] = val.FREEBIE_QUANTITY;
          this.purchase.amount_arr[i] = val.AMOUNT;
          this.purchase.actual_arr[i] = val.ACTUAL_AMOUNT;
          this.purchase.gross_arr[i] = val.GROSS_AMOUNT;
          this.purchase.quantity_arr[i] = val.QUANTITY;
          this.purchase.uom_arr_name[i] = val.UNIT_DESC;
          this.purchase.unitprice_arr[i] = val.UNIT_PRICE;
          this.purchase.retailprice_arr[i] = val.MRP;
          this.purchase.edit_qty_arr[i] = 0;
          this.purchase.ava_qty_arr[i] = val.AVAILABLE_STOCK_QUANTITY;
          this.purchase.vat_arr[i] = val.VAT;
          this.purchase.vat_amt_arr[i] = val.VAT_AMOUNT;
          this.purchase.warehouse[i] = val.WAREHOUSE_ID;
          if (val.ORDER_QUANTITY != null && val.ORDER_QUANTITY != '') {
            this.purchase.order_quantity_arr[i] = val.ORDER_QUANTITY;
            this.purchase.order_quantity[i] = val.RECEIVED_ORDER_QUANTITY + ' / ' + val.ORDER_QUANTITY;
            this.purchase.received_quantity[i] = val.RECEIVED_ORDER_QUANTITY;
          }
          i = i + 1;
        }
        this.purchase_details = num_rows

        this.totalAmount();
        this.getDropdowns();
        this.setVendor();
      } else {
        this.purchase = {
          vendor_id: '',
          invoice_no: '',
          invoice_date: new Date(),
          purchase_id: 0,
          medicine_data: [],
          medicine_id_arr: [""],
          purchase_details_id: [""],
          warehouse_details_id: [""],
          quantity_arr: [""],
          uom_arr: [""],
          uom_arr_name: [""],
          paking_arr: [""],
          amount_arr: [""],
          actual_arr: [""],
          edit_qty_arr: ["0"],
          ava_qty_arr: [""],
          unitprice_arr: [""],
          retailprice_arr: [""],
          dis_arr: [""],
          user_id: '',
          customer_trn: "",
          sor_no: {},
          customer_ref: "",
          sales_person: "",
          order_quantity_arr: [""],
          received_quantity: [""],
          order_quantity: [""],
          freebie_arr: ["0"],
          vat_arr: [""],
          gross_arr: [""],
          vat_amt_arr: [""],
          check: [""],
          upload_file: [],
          removeUpload: [],
          warehouse: [""]
        }
        this.fileName = []
      }
    });
  }

  public checkQuantity() {
    let result = false;
    this.purchase.order_quantity_arr.forEach((item: any, index: any) => {
      let bal_qty: number
      const order = parseInt(this.purchase.order_quantity_arr[index]);
      const p_qty = parseInt(this.purchase.purchased_quantity_arr[index]);
      const r_qty = parseInt(this.purchase.received_quantity[index]);
      if (order < p_qty) {
        this.toastr.error('Purchased quantity should be less than or equal to order quantity ');
        result = true;
      }
      bal_qty = order - r_qty;
      if (bal_qty < p_qty) {
        this.toastr.error('Purchased quantity should be less than or equal to order quantity ');
        result = true;
      }
    });
    return result;
  }

  public totalAmount() {
    let sum = 0;

    this.purchase.gross_arr.forEach((item: any, index: any) => {
      const amount = parseFloat(this.purchase.gross_arr[index]);
      if (!isNaN(amount)) {
        sum = sum + amount;
      }
    });
    this.total_amount = sum;

    const discper = parseFloat(this.purchase.disc_per);
    if (discper == 0 && this.purchase.discount > 0 && this.total_amount) {
      const per = (parseFloat(this.purchase.discount) / this.total_amount) * 100;
      this.purchase.disc_per = per.toFixed(2);
    }

    if (!isNaN(discper) && discper > 0) {
      const discount = (this.total_amount * (discper / 100));
      this.purchase.discount = discount.toFixed(2)
      this.net_total = Math.round(this.total_amount + parseFloat(this.purchase.freight_charge) - discount);
    } else {
      this.net_total = Math.round(this.total_amount + parseFloat(this.purchase.freight_charge) - parseFloat(this.purchase.discount));
    }


  }

  public getUnitPrice() {
    let price = 0;
    this.purchase.purchased_quantity_arr.forEach((item: any, index: any) => {
      const amount = parseFloat(this.purchase.amount_arr[index]);
      const qty = parseFloat(this.purchase.purchased_quantity_arr[index]);

      if (!isNaN(amount && qty)) {
        price = amount / qty;
      }
      this.purchase.unitprice_arr[index] = price.toFixed(2)
    });
  }

  public getActualPrice() {
    let actual = 0;
    this.purchase.purchased_quantity_arr.forEach((item: any, index: any) => {
      const amount = parseFloat(this.purchase.amount_arr[index]);
      const qty = parseFloat(this.purchase.purchased_quantity_arr[index]);
      const free_qty = parseFloat(this.purchase.freebie_arr[index]);

      if (!isNaN(amount && qty && free_qty)) {
        actual = amount / (qty + free_qty);
      }
      this.purchase.actual_arr[index] = actual.toFixed(2)
    });

  }

  public getAmount() {
    let vat_amount = 0;
    let vat_tot_amount = 0;
    this.purchase.amount_arr.forEach((item: any, index: any) => {
      const amount = parseFloat(this.purchase.amount_arr[index]);
      const vat = parseFloat(this.purchase.vat_arr[index]);


        if (!isNaN(amount && vat)) {
          vat_amount = amount * (vat / 100)
          this.purchase.vat_amt_arr[index] = vat_amount.toFixed(2)
          vat_tot_amount = vat_amount
        }
        this.purchase.gross_arr[index] = (amount + vat_tot_amount).toFixed(2)

    });
  }

  medicine_search = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(500),
      distinctUntilChanged(),
      tap(() => this.searching = true),
      switchMap(term =>
        this.consultingService.medicine_purchase_search(term, this.purchase.vendor_id).pipe(
          map((response: any) => {
            this.searchFailed = false
            if (response.status == 'Success') {
              return response.data;
            } else {
              return [];
            }
          }),
          catchError(() => {
            this.searchFailed = true;
            return of([])
          })
        )
      ),
      tap(() => this.searching = false)
    )

  formatter = (x: {
    TRADE_NAME: string,
    DDC_CODE: string,
    SCIENTIFIC_NAME: string,
    MEDICINE_ID: number,
    SCIENTIFIC_CODE: number
  }): any => x.TRADE_NAME;

  protected open_file(content: any) {
    this.modalRef = this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title'});
    this.modalRef.result.then((result: any) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  protected open(content: any) {
    this.modalService.open(content, {
      ariaLabelledBy: 'modal-basic-title',
      size: 'lg',
      windowClass: "col-md-12"
    }).result.then((result: any) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  protected bar(content: any) {
    this.modalService.open(content, {
      ariaLabelledBy: 'modal-basic-title',
      size: 'sm',
      windowClass: "col-md-12"
    }).result.then((result: any) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  protected credit(content: any) {
    this.modalService.open(content, {
      ariaLabelledBy: 'modal-basic-title',
      windowClass: "col-md-12"
    }).result.then((result: any) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  protected opens(content: any) {
    this.modalRef = this.modalService.open(content, {
      ariaLabelledBy: 'modal-basic-title',
      size: 'lg',
      windowClass: "col-md-12"
    });
    this.modalRef.result.then((result: any) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  protected getDismissReason(reason: any): string {
    if (reason == ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason == this.result_status) {
      return 'modal.dismiss()';
    } else if (reason == ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }

  }
}
